export const productFilterModal = () => {
  document.addEventListener('DOMContentLoaded', function () {
    const body = document.querySelector('body');
    const categoryOpenModalBtn = document.querySelector('#openFilterModalBtn');
    const filtersCloseModalBtn = document.querySelector('#filtersCloseModalBtn');
    const categoryContainer = document.querySelector('.filters-mobile');

    if (categoryOpenModalBtn) {
      categoryOpenModalBtn.addEventListener('click', (e) => {
        body.classList.add('modal-open');
        body.style.overflow = 'hidden';
        categoryContainer.style.display = 'block';

        setTimeout(function () {
          categoryContainer.classList.add('customArchiveProduct__category--modal');
        }, 100);
      });
    }

    if (filtersCloseModalBtn) {
      filtersCloseModalBtn.addEventListener('click', (e) => {
        categoryContainer.classList.remove('customArchiveProduct__category--modal');

        setTimeout(function () {
          body.classList.remove('modal-open');
          body.style.overflow = 'auto';
          categoryContainer.style.display = 'none';
        }, 300);
      });
    }

    // window.addEventListener('resize', function() {
    //   if (window.matchMedia('(min-width: 992px)').matches) {
    //     categoryContainer.classList.remove('customArchiveProduct__category--modal');
    //     body.classList.remove('modal-open');
    //     body.style.overflow = 'auto';
    //     categoryContainer.style.display = 'none';
    //   }
    // });
  });
}
